/**
 * Legal and finance requests (F5c).
 *
 * In `lib/` rather than a feature, following `activities` and `attachments`:
 * the record hangs off a startup today and the dashboard will want the
 * onboarding counts (F10), so both would need these hooks and plan §3.1 lets a
 * feature import only its own api/ layer.
 *
 * @see docs/plan/IMPLEMENTATION_PLAN.md task 7.9, PRD §5.11
 */
import type { LegalFinance, SaveLegalFinanceRequest } from '@nexus/contracts';

import { api } from './api-client';

export async function getLegalFinance(startupId: string): Promise<LegalFinance> {
  return api.get<LegalFinance>(`/startups/${startupId}/legal-finance`);
}

/**
 * Saves the record, creating it on first write.
 *
 * A `PUT`, matching the endpoint: there is exactly one record per startup, so
 * a client should not have to know whether it exists yet in order to save a
 * field.
 */
export async function saveLegalFinance(
  startupId: string,
  body: SaveLegalFinanceRequest,
): Promise<LegalFinance> {
  return api.put<LegalFinance>(`/startups/${startupId}/legal-finance`, body);
}
